<template>
 <d-row>
      <d-col lg="8">
  <d-alert class="alert-royal-blue" :show="show_alert" theme="danger" ref="dalert" style="position:sticky;top:0;left:0;z-index:10000;" dismissible >
    <i class="fa fa-info mx-2"></i>
    <span id="warning">{{ error_msg }}</span> 
  </d-alert>

  <d-card class="card-small mb-4">
    <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#FF6700"/>
    <!-- Card Header -->
    <d-card-header class="border-bottom">
       <d-button type="button" :disabled="loading" class="btn-accent" @click="save_form" data-toggle="tooltip" data-placement="top" title="Save Form" ><i class="material-icons">save_alt</i> Save</d-button>&nbsp;
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <d-form>
              <d-form-row>

                <!-- Name -->
                <d-col md="6" :class="{ 'form-group--error' : $v.name.$error }">
                  <label for="fename">Nama</label>
                  <d-form-input type="text" id="name" placeholder="nama" v-model.trim="$v.name.$model" />
                  <div  class="verror" v-if="!loading && !$v.name.required">Harap isi kolom ini</div>
                </d-col>

              </d-form-row>

            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
      </d-col>
 </d-row>
</template>
<style>
.item {
  display: flex;
  align-items: center;
}

.item-name {
  font-size: 12px;
}
</style>
<script>
import VueElementLoading from 'vue-element-loading';
import env from '../../env.vue';
import { required } from 'vuelidate/lib/validators';

export default {
  components: {
    VueElementLoading,
  },
  name: 'location-info',
  data(){
    return {
      form:'',
      id:'',
      name:'',
      value:'',
      loading:false,
      old_data:[],
      error_msg:'',
      show_alert:false,
    }
  },
  validations:{
    name:{ required },
  },
  watch: {
    '$route.query.id'(newId,oldId){
      if (newId!=oldId){
        if ( newId==0 ) this.resetForm();
      }
    },
  },
  methods: {
    save_form(){
        let dthis=this;        
        let submit=true;
/*
        Object.keys(this.old_data).forEach( key=>{
          if ( JSON.stringify(eval('dthis.'+key))!==JSON.stringify(eval('dthis.old_data.'+key)) ){
            submit=true;
          }
        });
*/
        if (submit){
          this.loading=true;
          this.axios.post( env.server+'/location/save/'+this.id,
          {
            name:this.name,
          }).then( resp=>{
            this.loading=false;
            this.$buefy.toast.open({ message:'Data saved',
              position: 'is-bottom',
              type: 'is-success',
            });
          }).catch(e=>{
            this.pop_alert(JSON.parse(e.response.data));
            this.loading=false;
          })
        }
    },
    pop_alert(msg){
      if (msg==undefined) return;
      this.$refs.dalert.dismissed=false;
      this.show_alert=5;
      this.error_msg=msg;
    },
    resetForm(){
      var dthis=this;
      this.old_data={ 
      name:'',
      }
      Object.keys(this.old_data).forEach( key=>{
        eval('dthis.'+key+'=\'\'');
      });        
    }
  },
  mounted(){
    this.id=this.$route.query.id;
    if ( this.id>0 ){
      this.loading=true;
      this.axios.get( env.server+'/location/load/'+this.id).then(
        resp=>{
          resp.data = JSON.parse(resp.data);
          resp.data = resp.data.data;
          this.name=resp.data.name;
          this.loading=false;
          }
      )
    } else {
      this.resetForm()
    }
  },
};
</script>
